import Avatar from "@/components/base/Avatar";
import { siteVoices } from "@/mocks/site";

const tones = ["primary", "accent", "secondary"] as const;

export default function VoicesSection() {
  return (
    <section className="w-full border-y border-background-200 bg-secondary-50 py-12 md:py-16">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6">
        <div className="max-w-2xl">
          <span className="flex items-center gap-2 text-xs font-medium tracking-wide text-secondary-700">
            <span className="flex h-4 w-4 items-center justify-center">
              <i className="ri-chat-quote-line text-base" />
            </span>
            围观口碑
          </span>
          <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            围观群众怎么说
          </h2>
          <p className="mt-2 text-sm text-foreground-600">
            他们来自不同的城市、不同的作息，却因为同一个话题坐在了同一块瓜田里。
          </p>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {siteVoices.map((voice, index) => (
            <figure
              key={voice.id}
              className="flex h-full flex-col rounded-card border border-secondary-200 bg-background-50 p-5"
            >
              <span className="flex h-8 w-8 items-center justify-center text-secondary-500">
                <i className="ri-double-quotes-l text-2xl" />
              </span>
              <blockquote className="mt-2 flex-1 text-sm leading-relaxed text-foreground-700">
                {voice.text}
              </blockquote>
              <figcaption className="mt-5 flex items-center gap-3 border-t border-secondary-100 pt-4">
                <Avatar name={voice.user} tone={tones[index % tones.length]} size="sm" />
                <span className="min-w-0">
                  <span className="block truncate text-sm font-medium text-foreground-900">
                    {voice.user}
                  </span>
                  <span className="block truncate text-xs text-foreground-500">{voice.topic}</span>
                </span>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}